<template>
  <div>
    <h2 class="text-xl font-bold mb-4">{{ device.name }}</h2>
    <table class="table table-bordered table-hover">
      <tr>
        <th>{{$t('serial')}}</th>
        <td>{{ device.serial }}</td>
      </tr>
      <tr>
        <th>{{$t('last_event')}}</th>
        <td>{{fmtDate(device.tracker_status.last_event)}}</td>
      </tr>
      <tr>
        <th>{{$t('state')}}</th>
        <td>{{device.tracker_status.state}}</td>
      </tr>
      <tr>
        <th>{{$t('battery')}}</th>
        <td>
          <div v-if="device.tracker_status"> {{device | formatBattery}}</div>
        </td>
      </tr>
      <tr>
        <th>{{$t('network')}}</th>
        <td>
          <div v-if="device.tracker_config">{{ device.tracker_config.network }}</div>
        </td>
      </tr>
      </tr>
      <tr>
        <th>{{$t('subscription_end_date')}}</th>
        <td>
          <div v-if="device.tracker_status">{{device.tracker_status.sub_end_date| formatDay}}</div>
        </td>
      </tr>
    </table>
    <TrackerChangeMode :device="device" v-if="allowChangeMode" />
    <div class="mt-4 position-relative">
      <div v-if="!allowUnlinkDevice" class="overlay"></div>
      <div class="d-flex align-items-center">
        <input type="checkbox" v-model="confirmUnlinkDevice" id="confirm-unlink-device" class="me-2" :disabled="!allowUnlinkDevice">
        <p class="ml-2 mb-0">{{$t('unlink_warn_msg')}}</p>
      </div>
      <button class="mt-2 btn btn-danger" :disabled="!confirmUnlinkDevice|| !confirmUnlinkDevice" @click="unlinkDevice">{{ $t('unlink_from_account') }}</button>
    </div>
  </div>
</template>
<script>
import * as nvxlib from "@/nvxcommon";
import TrackerChangeMode from "@/components/TrackerChangeMode.vue";

export default {
  name: 'TrackerDetail',
  components: {TrackerChangeMode},
  data: function () {
    return {
      mode_param: undefined,
      confirmUnlinkDevice: false
    }
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    allowChangeMode() {
      if (!this.device.tracker_config) {
        return false;
      }
      if (this.device.tracker_config.network === 'sigfox') {
        return false;
      }
      console.log("allowChangeMode", this.device.tracker_config.mode);
      return (['50', '235'].includes(this.device.tracker_config.mode));
    },
    allowUnlinkDevice() {
      console.log("allowUnlinkDevice", this.device.tracker_status.state);
      return this.device.tracker_status.state !== 'online';
    },
  },
  methods: {
    unlinkDevice() {
      const self = this;
      if (this.confirmUnlinkDevice) {

        nvxlib.unlinkDevice(this.device, function (result) {
          console.log("Unlinking device with result", result);
          self.$emit('exit-component');
        });
      }
    },
    fmtDate(date) {
      return nvxlib.fmtDate(date);
    }
  },
  mounted() {
    const self = this;
    nvxlib.getModeParam(this.device, function (mode_param) {
      self.mode_param = mode_param;
    });
  }

}
</script>
<style>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5); /* Light transparency */
  z-index: 10;
  pointer-events: all; /* Prevent clicks */
}
</style>